import { CaretRight, Student, UsersThree } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { ServerScreen } from '../../components/layout/Screens';
import { t } from '../../i18n';

/**
 * L'accueil de l'annuaire d'une ecole : les etudiants, ou les associations.
 *
 * Deux portes plutot qu'une liste : on ne cherche pas de la meme facon
 * quelqu'un croise en cours et le club qu'on veut rejoindre. Les
 * etudiants restent ranges par formation ; les associations ont chacune
 * leur page, leur fil et leurs evenements.
 */
export function AnnuaireScreen() {
  const textes = t.messages.annuaire.accueil;
  return (
    <ServerScreen>
      <div className="an an-accueil">
        <Porte
          vers="/app/annuaire/etudiants"
          icone={<Student size={28} />}
          titre={textes.etudiants}
          aide={textes.etudiantsAide}
        />
        <Porte
          vers="/app/annuaire/associations"
          icone={<UsersThree size={28} />}
          titre={textes.associations}
          aide={textes.associationsAide}
        />
      </div>
    </ServerScreen>
  );
}

function Porte({ vers, icone, titre, aide }: { vers: string; icone: React.ReactNode; titre: string; aide: string }) {
  return (
    <Link to={vers} className="card an-porte">
      <span className="an-porte__icone">{icone}</span>
      <span className="an-porte__texte">
        <span className="an-porte__titre">{titre}</span>
        <span className="an-porte__aide">{aide}</span>
      </span>
      <CaretRight className="sens-x an-porte__fleche" size={18} />
    </Link>
  );
}
